import { render, staticRenderFns } from "./UiIconItem.vue?vue&type=template&id=6ef77197&"
import script from "./UiIconItem.vue?vue&type=script&lang=js&"
export * from "./UiIconItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports